export default __webpack_public_path__ + "static/media/img_muslinTwoEarsBib_yg_p.f75169f3.jpg";